import api from '../config/axios';

const reportBuilderService = {
  // Templates CRUD
  getTemplates: async (params = {}) => {
    const response = await api.get('/api/report-builder/templates', { params });
    return response.data;
  },

  getTemplate: async (id) => {
    const response = await api.get(`/api/report-builder/templates/${id}`);
    return response.data;
  },

  createTemplate: async (data) => {
    const response = await api.post('/api/report-builder/templates', data);
    return response.data;
  },

  updateTemplate: async (id, data) => {
    const response = await api.put(`/api/report-builder/templates/${id}`, data);
    return response.data;
  },

  deleteTemplate: async (id) => {
    const response = await api.delete(`/api/report-builder/templates/${id}`);
    return response.data;
  },

  duplicateTemplate: async (id) => {
    const response = await api.post(`/api/report-builder/templates/${id}/duplicate`);
    return response.data;
  },

  // Widget catalog and data sources
  getWidgetCatalog: async () => {
    const response = await api.get('/api/report-builder/widget-catalog');
    return response.data;
  },

  getDataSources: async () => {
    const response = await api.get('/api/report-builder/data-sources');
    return response.data;
  }
};

export default reportBuilderService;



// ==========================================
// SCHEDULE API
// ==========================================

export const getSchedules = async () => {
  const response = await api.get('/api/report-builder/schedules');
  return response.data;
};

export const getSchedule = async (id) => {
  const response = await api.get(`/api/report-builder/schedules/${id}`);
  return response.data;
};

export const createSchedule = async (data) => {
  const response = await api.post('/api/report-builder/schedules', data);
  return response.data;
};

export const updateSchedule = async (id, data) => {
  const response = await api.put(`/api/report-builder/schedules/${id}`, data);
  return response.data;
};

export const deleteSchedule = async (id) => {
  const response = await api.delete(`/api/report-builder/schedules/${id}`);
  return response.data;
};

export const toggleSchedule = async (id) => {
  const response = await api.post(`/api/report-builder/schedules/${id}/toggle`);
  return response.data;
};

export const runScheduleNow = async (id) => {
  const response = await api.post(`/api/report-builder/schedules/${id}/run-now`);
  return response.data;
};

export const sendTestEmail = async (email) => {
  const response = await api.post('/api/report-builder/test-email', { email });
  return response.data;
};

// ==========================================
// SHARE API
// ==========================================

export const shareReport = async (templateId) => {
  const response = await api.post(`/api/report-builder/templates/${templateId}/share`);
  return response.data;
};

export const unshareReport = async (templateId) => {
  const response = await api.post(`/api/report-builder/templates/${templateId}/unshare`);
  return response.data;
};

export const getPublicReport = async (shareId) => {
  const response = await api.get(`/api/report-builder/public/${shareId}`);
  return response.data;
};

export const uploadReportImage = async (file) => {
  const formData = new FormData();
  formData.append('image', file);
  const response = await api.post('/report-builder/upload-image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};
